/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { useGoogleAnalytics } from 'volto-google-analytics';

import {
  FooterMain,
  FooterSmall,
  SubsiteFooter,
} from 'design-comuni-plone-theme/components/ItaliaTheme/';

import { FeedbackForm } from 'design-comuni-plone-theme/components/ItaliaTheme';
import config from '@plone/volto/registry';
/**
 * Footer component class.
 * @class Footer
 * @extends Component
 */

const Footer = () => {
  useGoogleAnalytics();
  const currentContent = useSelector((state) => state.content?.data);
  const contentType = currentContent ? currentContent['@type'] : null;
  const noFeedbackFormFor = config.settings.siteProperties.noFeedbackFormFor || [];

  return (
    <>
      {contentType &&
        !noFeedbackFormFor.includes(contentType) &&
        config.settings.siteProperties.enableFeedbackForm && (
          <FeedbackForm />
        )}

      <SubsiteFooter />
      <footer className="it-footer" id="footer">
        <div class="py-5 bg-light full-width row d-flex justify-content-center p-contacts">
          <div class="col-12 col-lg-4">
            <div class="cmp-contacts">
              <div class="bg-white p-4">
                <div class="card-body simple-list-template"><strong><span class="text-larger">Contatta il comune</span></strong>
                  <ul>
                    <li><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="icon fa-icon fal icon"
                      aria-labelledby="3596080c-16a4-4fb3-ab3d-b61cf53ecd60" aria-hidden="true">
                      <path
                        d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z">
                      </path>
                    </svg><a class="ms-2" href="https://www.comune.budrio.bo.it/leggi-le-faq">Leggi le domande frequenti</a></li>
                    <li><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="icon fa-icon fal icon"
                      aria-labelledby="3596080c-16a4-4fb3-ab3d-b61cf53ecd60" aria-hidden="true">
                      <path
                        d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z">
                      </path>
                    </svg><a class="ms-2" href="https://servizi.comune.budrio.bo.it/portal/richiesta-di-assistenza#/assistance">Richiesta assistenza</a></li>
                    <li><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="icon fa-icon fal icon"
                      aria-labelledby="3596080c-16a4-4fb3-ab3d-b61cf53ecd60" aria-hidden="true">
                      <path
                        d="M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z">
                      </path>
                    </svg><a class="ms-2" href="https://servizi.comune.budrio.bo.it/portal/prenotazione-appuntamento#/nuovo-appuntamento">Prenota un appuntamento</a></li>
                  </ul><strong><span class="text-larger">Problemi in città</span></strong>
                  <ul>
                    <li><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="icon fa-icon fal icon"
                      aria-labelledby="3596080c-16a4-4fb3-ab3d-b61cf53ecd60" aria-hidden="true">
                      <path
                        d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z">
                      </path>
                    </svg><a class="ms-2" href="https://www.comune.budrio.bo.it/segnalazione-disservizio">Segnala un disservizio</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FooterMain />
        <FooterSmall />
      </footer>
    </>
  );
};

export default Footer;
